import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  alert: {
    marginBottom: 10,
  },
  heading: {
    marginBottom: '30px',
  },
  paper: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  unverifiedRow: {
    background: 'rgb(253, 237, 237)',
  },
  headerBar: {
    display: 'flex',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  button: {
    height: 40,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: theme.spacing(2),
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
  grid: {
    flex: 1,
    minHeight: 0,
  },
  gridItem: {
    display: 'flex',
    minHeight: 0,
  },
  tableModeText: {
    fontSize: '0.72rem',
    color: theme.palette.custom.secondary2,
    marginBottom: theme.spacing(0.75),
    flexShrink: 0,
  },
  tableModeLink: {
    fontSize: '0.72rem',
    color: theme.palette.custom.primary1,
    textDecoration: 'underline',
  },
  dataGrid: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
}));

export default useStyles;
